import React from "react";

const OutstandingPaymentsTable = ({ outstandingData }) => {
	const formatCurrency = (amount, currency = "USD") => {
		const symbol = currency === "INR" ? "₹" : "$";
		return `${symbol}${new Intl.NumberFormat('en-US', {
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		}).format(amount || 0)}`;
	};

	const formatDate = (date) => {
		return new Date(date).toLocaleDateString('en-US', {
			month: 'short',
			day: 'numeric',
			year: 'numeric'
		});
	};

	const getStatusBadge = (status, overdueDays) => {
		const styles = {
			overdue: { bg: "var(--danger-color)", text: "white", icon: "🔴" },
			due_soon: { bg: "var(--warning-color)", text: "white", icon: "🟡" },
			not_due: { bg: "var(--success-color)", text: "white", icon: "🟢" }
		};

		const style = styles[status] || styles.not_due;
		const label = status === "overdue" 
			? `${overdueDays}d overdue`
			: status === "due_soon"
			? "Due soon"
			: "Not due";

		return (
			<span style={{
				display: "inline-flex",
				alignItems: "center",
				gap: "6px",
				padding: "4px 10px",
				borderRadius: "12px",
				background: style.bg,
				color: style.text,
				fontSize: "11px",
				fontWeight: "700"
			}}>
				<span>{style.icon}</span>
				<span>{label}</span>
			</span>
		);
	};

	return (
		<div>
			<div style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				marginBottom: "var(--spacing-xl)"
			}}>
				<div>
					<h3 style={{ margin: 0, fontSize: "20px", fontWeight: "700" }}>
						Outstanding Payments
					</h3>
					<p style={{ margin: "4px 0 0 0", color: "var(--text-muted)", fontSize: "13px" }}>
						Total: {formatCurrency(outstandingData.summary.totalOutstandingUSD)} (
						{formatCurrency(outstandingData.summary.totalOutstandingINR, "INR")})
					</p>
				</div>
				<div style={{ display: "flex", gap: "var(--spacing-md)", fontSize: "12px", fontWeight: "600" }}>
					<span style={{ color: "var(--danger-color)" }}>
						🔴 Overdue: {outstandingData.summary.overdueCount}
					</span>
					<span style={{ color: "var(--warning-color)" }}>
						🟡 Due Soon: {outstandingData.summary.dueSoonCount}
					</span>
					<span style={{ color: "var(--success-color)" }}>
						🟢 Not Due: {outstandingData.summary.notDueCount}
					</span>
				</div>
			</div>

			<div className="table-container-v4">
				<table className="data-table-v4">
					<thead>
						<tr>
							<th>Invoice Month</th>
							<th>Partner</th>
							<th>Invoice Amount</th>
							<th>Received</th>
							<th>Pending</th>
							<th>Due Date</th>
							<th>Status</th>
						</tr>
					</thead>
					<tbody>
						{outstandingData.outstandingPayments.map((payment, index) => (
							<tr key={index}>
								<td>
									<div style={{ fontWeight: "600" }}>
										{new Date(payment.invoiceMonth + "-01").toLocaleDateString('en-US', {
											month: 'short',
											year: 'numeric'
										})}
									</div>
									<div className="text-mono-v4" style={{ fontSize: "10px" }}>
										{payment.invoiceNumber}
									</div>
								</td>
								<td>
									<div style={{ fontWeight: "600" }}>{payment.partnerName}</div>
								</td>
								<td>
									<div style={{ fontWeight: "600" }}>
										{formatCurrency(payment.invoiceAmountUSD)}
									</div>
									<div style={{ fontSize: "11px", color: "var(--text-muted)" }}>
										{formatCurrency(payment.invoiceAmountINR, "INR")}
									</div>
								</td>
								<td>
									<div style={{ fontWeight: "600", color: "var(--success-color)" }}>
										{formatCurrency(payment.receivedUSD)}
									</div>
									<div style={{ fontSize: "11px", color: "var(--text-muted)" }}>
										{formatCurrency(payment.receivedINR, "INR")}
									</div>
								</td>
								<td>
									<div style={{ fontWeight: "600", color: "var(--danger-color)" }}>
										{formatCurrency(payment.pendingUSD)}
									</div>
									<div style={{ fontSize: "11px", color: "var(--text-muted)" }}>
										{formatCurrency(payment.pendingINR, "INR")}
									</div>
								</td>
								<td>
									<div style={{
										fontWeight: "600",
										color: payment.status === "overdue" ? "var(--danger-color)" : "inherit"
									}}>
										{formatDate(payment.dueDate)}
									</div>
								</td>
								<td>
									{getStatusBadge(payment.status, payment.overdueDays)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default OutstandingPaymentsTable;